"use client"

import React, { useMemo, useState, useCallback } from "react"
import ProductCard from "./ProductCard"
import useMutation from "@src/hooks/use-mutation"
import Toastify from "@src/components/Toastify"
import { useCurrentUser } from "@src/hooks/use-current-user"
import dynamic from "next/dynamic"
export { ProductCardSkeleton } from "./ProductCardSkeleton"

// The quick-view tree (lightbox, carousels, forms) loads only when opened.
const ModalProduct = dynamic(() => import("./ModalProduct"), { ssr: false })

const WrapperProductCard = props => {
  const { product, onCallBackToggleLike } = props
  const { update, user } = useCurrentUser()
  const { mutation } = useMutation()

  const [selectedProduct, setSelectedProduct] = useState(null)

  const { product_ids } = user || {}

  const isLiked = useMemo(() => {
    return product_ids?.includes(product?.id)
  }, [product_ids?.length, product?.id])

  const showModalDetail = useCallback(() => {
    setSelectedProduct(product)
  }, [])

  const onCloseModal = useCallback(() => {
    setSelectedProduct(null)
  }, [])

  const toggleLike = status => async () => {
    if (product?.slug) {
      if (status) {
        await mutation({
          url: `/auth/wishlist/product/${product.slug}/addToWishlist`,
          method: "POST",
          onSuccess: res => {
            if (res) {
              Toastify.success(res.message || "Đã thêm vào yêu thích")
              update({
                ...user,
                product_ids: [...product_ids, product.id],
                type: "LOCAL_UPDATE"
              })
              onCallBackToggleLike?.()
            }
          }
        })
      } else {
        await mutation({
          url: `/auth/wishlist/product/${product.slug}/removeFromWishlist`,
          method: "DELETE",
          onSuccess: res => {
            if (res) {
              Toastify.success(res.message || "Đã xóa khỏi yêu thích")
              update({
                ...user,
                product_ids: product_ids.filter(item => item !== product.id),
                type: "LOCAL_UPDATE"
              })
              onCallBackToggleLike?.()
            }
          }
        })
      }
    }
  }

  return (
    <>
      <ProductCard
        {...props}
        isLiked={isLiked}
        toggleLike={toggleLike}
        onSelectedProduct={showModalDetail}
      />
      {selectedProduct && (
        <ModalProduct
          open={true}
          selectedProduct={product}
          onClose={onCloseModal}
        />
      )}
    </>
  )
}

export default WrapperProductCard
